import {
  type ChanelActionType,
  type IncomingMessagePayload,
  type IWebSocketConnection,
  PrivateConnectionChannels,
  type RepositoryWS,
  WebSocketConnectionManager
} from "../../index";
import type { BalanceModel } from "@trading/core";

export class BalanceRepoWs implements RepositoryWS<BalanceModel> {
  private wsChannel = PrivateConnectionChannels['BALANCES']
  // private connection = WebSocketConnectionManager.getInstance().getConnection('private')
  private unsubscribeHandler: (() => void) = () => { throw new Error("Method not initialized."); }
  private unsubscribeChannel: (() => void) = () => { throw new Error("Method not initialized."); }

  constructor(private wsManager: WebSocketConnectionManager) {}

  public unsubscribeToChannel(): void {
    this.unsubscribeHandler()
    this.unsubscribeChannel()
  }

  async subscribeToChannelsAction(
    actionName: ChanelActionType,
    cb: (order: BalanceModel) => void
  ): Promise<undefined | ReturnType<IWebSocketConnection['subscribeToChannelMessages']>> {
    const connection = await this.wsManager.getConnection('private')

    const unsubscribeChannel = connection.subscribeToChannelMessages(this.wsChannel)
    const unsubscribeHandler = connection.addChannelHandler(this.wsChannel, (data: IncomingMessagePayload<BalanceModel>) => {
      if (data.type === actionName) {
        cb(data.data)
      }
    })
    this.unsubscribeChannel = unsubscribeChannel
    this.unsubscribeHandler = unsubscribeHandler
    return () => {
      unsubscribeHandler()
      unsubscribeChannel()
    }
  }
}
